import { TaskItem as OriginalTaskItem } from "@tiptap/extension-list";

export const TaskItem = OriginalTaskItem.extend({
  addOptions() {
    const parentOptions = this.parent?.();
    return {
      ...parentOptions,
      nested: true,
      HTMLAttributes: {
        ...parentOptions?.HTMLAttributes,
        class:
          "flex items-baseline [&>label]:mr-2 [&>label>input]:accent-blue-500 [&>div]:flex-1 [&>div]:min-w-0 [&>div>p]:my-0 " +
          "[&>label]:relative [&>label]:flex [&>label]:w-[15px] [&>label]:h-[15px] [&>label]:translate-y-[2px] " +
          "[&>label>input]:appearance-none [&>label>input]:w-full [&>label>input]:h-full [&>label>input]:rounded-3 [&>label>input]:border [&>label>input]:border-gray-300 " +
          "[&>label>input:checked]:bg-blue-500 [&>label>input:checked]:border-blue-500 " +
          "[&>label>span]:absolute [&>label>span]:left-0 [&>label>span]:top-0 [&>label>span]:w-full [&>label>span]:h-full [&>label>span]:flex [&>label>span]:items-center [&>label>span]:justify-center " +
          "[&>label>span::before]:content-['✓'] [&>label>span::before]:text-[13px] [&>label>span::before]:leading-0 [&>label>span::before]:text-white [&>label>span::before]:translate-y-[-0.02rem] " +
          "[&>label>input:not(:checked)+span]:hidden",
      },
    };
  },

  addNodeView() {
    const parentNodeView = this.parent?.();
    if (!parentNodeView) {
      return null;
    }

    return (props) => {
      const nodeView = parentNodeView(props);
      const { editor, getPos } = props;
      const checkboxWrapper =
        nodeView.dom instanceof HTMLElement ? nodeView.dom.firstElementChild : null;

      // The upstream change handler focuses the editor, which opens the
      // on-screen keyboard on mobile. Intercept before it runs and toggle
      // without focusing.
      checkboxWrapper?.addEventListener("mousedown", (event) => event.preventDefault());
      checkboxWrapper?.addEventListener(
        "change",
        (event) => {
          if (!editor.isEditable || !(event.target instanceof HTMLInputElement)) {
            return;
          }
          event.stopPropagation();

          const position = getPos();
          if (typeof position !== "number") {
            return;
          }
          const { checked } = event.target;
          editor.view.dispatch(editor.state.tr.setNodeAttribute(position, "checked", checked));
        },
        { capture: true },
      );

      return nodeView;
    };
  },
});
